import commons from '@ehi/core-aem65-ui-frontend';
import { accordionCheerio } from '@ehi/core-aem65-ui-frontend/accordionCheerio';

export default {
  init(_, domEl) {
    const containerUtils = window?.CQ?.CoreComponents?.container?.utils
      ? window.CQ.CoreComponents.container.utils
      : null;
    const accordionButtons = domEl.querySelectorAll('[data-cmp-hook-accordion="button"]');
    const expandPanel = (panel) => {
      if (panel.classList.contains('cmp-accordion__panel--expanded')) {
        containerUtils.removeUrlHash();
      }
    };

    commons.init();
    accordionCheerio.init();

    // This logic specifically to remove the accordion item being being added to hasUrl
    accordionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        expandPanel(panel);
      });
    });
  },
};
